
import highFlare from "../images/highFlare.svg";

const FlareEffect = () => {
  return (
    <div>
      <div className="flex justify-center items-center">
        <img
          src={highFlare}
          alt="flare"
          className="w-[50px] h-[50px] object-contain transition-opacity animate-pulse duration-700 ease-in-out"
        />
      </div>
    </div>
  );
};

export default FlareEffect;
